<template>
  <div
    class="relative w-full cursor-pointer max-w-full"
    :class="isMobile ? 'h-gap-screen overflow-hidden' : 'h-gap-screen'"
    :data-title="activity.title"
    :data-uri="activity.uri"
    v-on:click="$router.push(activity.uri)"
  >
    <video
      v-if="!isMobile && activity.use_video"
      ref="video"
      class="absolute w-full h-full object-cover"
      data-object-fit
      :src="activity.cover_video.file"
      :poster="activity.cover_video.poster"
      playsinline
      loop
      muted="true"
    />
    <img
      v-else
      v-lazy="activity.cover_image.src"
      :data-srcset="activity.cover_image.srcset"
      class="absolute w-full h-full object-cover"
      :class="{ highlight: isMobile && highlight }"
      data-object-fit
    />
    <div
      v-if="!isMobile"
      class="w-1/3 sticky"
      :class="calcInfoBoxStyles"
    >
      <div class="w-full h-full flex flex-col justify-between p-4 bg-white">
        <div class="flex flex-row justify-center lg:justify-between">
          <div class="flex-grow-1 whitespace-no-wrap">{{ displayDate }}&nbsp;&nbsp;</div>
          <div class="flex-grow-0 truncate text-right hidden lg:block">{{ displayEvents }}</div>
        </div>
        <div class="text-center">
          <h1>{{ activity.title }}</h1>
          <div>{{ displayResponsible }}</div>
        </div>
        <div class="text-center truncate">
          {{ activity.location }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import 'objectFitPolyfill'
import { formatDateOrRange, capitalize } from '@/util'

export default {
  name: 'FeaturedActivityPreview',

  props: ['isMobile', 'activity', 'blockPosition', 'highlight'],

  watch: {
    highlight (val, oldVal) {
      const video = this.$refs.video
      if (video === undefined) {
        return
      }

      if (val && !oldVal) {
        video.play()
      } else if (!val && oldVal) {
        video.pause()
      }
    }
  },

  computed: {
    displayDate () {
      return formatDateOrRange(this.activity.begin_date, this.activity.end_date)
    },

    displayEvents () {
      return this.activity.related_events.length ? this.activity.related_events[0].title : ''
    },

    displayResponsible () {
      if (this.activity.related_people.length === 0) {
        return ''
      }

      const group = this.activity.related_people[0]
      const names = group.people.map(p => {
        return p.title
      })
      return capitalize(group.label) + ' ' + names.join(', ');
    },

    calcInfoBoxStyles () {
      let styles = 'h-1/2'
      switch (this.blockPosition) {
        case 0:
          styles += ' top-0 left-0'
          break;
        case 1:
          styles += ' top-0 left-1/3'
          break;
      }

      return styles
    }
  },

  mounted () {
    if (this.$refs.video) {
      const element = this.$refs.video
      window.objectFitPolyfill(element)
    }
  }
}
</script>

<style scoped>
img {
  max-width: initial;
  transition: transform .3s ease-in-out;
}

img.highlight {
  transform: scale(1.05);
}
</style>
